import { Box, Typography } from '@mui/material';

export function FreeBadge(): React.JSX.Element {
  return (
    <Box
      alignItems="center"
      bgcolor="#eee8fd"
      border="1px solid #B396EF"
      borderRadius={2}
      display="flex"
      gap={0.5}
      paddingX={1}
      paddingY={0.5}
    >
      <Typography color="#6236bd" lineHeight="14px" variant="caption">
        Offre gratuite
      </Typography>
    </Box>
  );
}
